import { SelectItem } from '#components/patterns/forms/select/select-item/SelectItem.tsx';
import { SelectControlled } from '#components/patterns/forms/select/select/SelectControlled.tsx';
import type { FormData } from '../../../form-types.ts';
import { getOptionName, TARGET_TYPES } from './TargetTypeSelect.tsx';

type Props = Omit<
  React.ComponentProps<typeof SelectControlled<FormData, 'targetType'>>,
  'name' | 'label' | 'renderValue' | 'renderOptions'
>;

export function TargetTypeSelectControlled(props: Props) {
  return (
    <SelectControlled
      {...props}
      label="Filter"
      name="targetType"
      renderValue={getOptionName}
      renderOptions={({ onChange }) => (
        <>
          {TARGET_TYPES.map((tt) => (
            <SelectItem
              key={tt}
              value={tt}
              onClick={() => {
                onChange(tt);
              }}
            >
              {getOptionName(tt)}
            </SelectItem>
          ))}
        </>
      )}
    />
  );
}
